import { useState } from "react";
import { GetProfileWeeklySummaryQuery } from "types/graphql-schema";

import ToggleChevronIcon from "@components/layout/toggle-chevron-icon";

import SummaryLine from "./summary-line";

type SummaryLineData = NonNullable<
  GetProfileWeeklySummaryQuery["profileWeeklySummary"]
>["insights"][number];

// A collapsible section ("Insights", "{Name}'s Activity") of sparkle-bulleted
// lines. Renders nothing when it has no lines.
const SummarySection = ({
  title,
  lines,
  variant,
}: {
  title: string;
  lines: readonly SummaryLineData[];
  variant: "insight" | "activity";
}) => {
  const [expanded, setExpanded] = useState(true);

  if (lines.length === 0) return null;

  return (
    <div className="flex flex-col gap-3">
      <button
        onClick={() => setExpanded((value) => !value)}
        className="flex w-fit items-center gap-1.5 text-sm font-semibold text-gray-900"
      >
        {title}
        <ToggleChevronIcon expanded={expanded} />
      </button>
      {expanded && (
        <div className="flex flex-col gap-3.5">
          {lines.map((line) => (
            <SummaryLine key={line.id} line={line} variant={variant} />
          ))}
        </div>
      )}
    </div>
  );
};

export default SummarySection;
